
import { Component, Vue, Prop } from "vue-property-decorator";
import { RegistrationService } from "@/InscriptionFlow/services/RegistrationService";
import { AuthenticationService } from "@/InscriptionFlow/services/AuthenticationService";
import ErrorHelper from "@/Commons/ErrorHelper";
import { RegistrationStatus } from "@/InscriptionFlow/models/enums/RegistrationStatus";
import { AuthenticationStatus } from "@/InscriptionFlow/models/enums/AuthenticationStatus";
import OverlayProgressCircular from "@/Commons/components/OverlayProgressCircular.vue";
import FooterPanelVuetify from "@/Commons/components/FooterPanelVuetify.vue";
import { getModule } from "vuex-module-decorators";
import { AccountDetectionModeModule } from "@/InscriptionFlowsAdmin/store/modules/AccountDetectionModeModule";
import { AccountDetectionModes } from "@/InscriptionFlow/models/enums/AccountDetectionModes";

@Component({
  components: {
    OverlayProgressCircular,
    FooterPanelVuetify
  }
})
export default class AccountAssociation extends Vue {
  @Prop({ type: String, required: true })
  private email!: string;
  @Prop({ type: String, required: true })
  private nationalId!: string;
  @Prop({ type: String, required: true })
  private flowName!: string;
  @Prop({ type: Boolean, required: true })
  private linking!: boolean;

  private login = "";
  private password = "";
  private forgottenPasswordUri = "javascript:void(0)";
  private forgottenLoginUri = "javascript:void(0)";
  private linkError?: string | null = null;
  private submitting = false;
  private accountDetectionModesModule = getModule(AccountDetectionModeModule);

  submit() {
    this.submitting = true;
    if (!this.linking) {
      const authenticationPromise =
        this.accountDetectionModesModule.flowADM === AccountDetectionModes.Email
          ? AuthenticationService.authenticateEmail(
              this.flowName,
              this.login,
              this.password,
              this.email
            )
          : AuthenticationService.authenticateNationalId(
              this.flowName,
              this.login,
              this.password,
              this.nationalId
            );

      authenticationPromise
        .then(() => {
          this.$router.push({ name: "inscription-flow-register" });
        })
        .catch(error => {
          switch (error.response.data) {
            case AuthenticationStatus.AuthenticationError:
              this.linkError =
                this.accountDetectionModesModule.flowADM ===
                AccountDetectionModes.Email
                  ? this.$texts.authenticationByEmailError
                  : this.$texts.authenticationByNationalIdError;
              break;
            default:
              this.linkError = ErrorHelper.getWebApiErrorMessage(error);
              break;
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    } else {
      RegistrationService.linkAccount(
        this.flowName,
        this.login,
        this.password,
        this.email,
        this.nationalId
      )
        .then(() => {
          this.$router.push({ name: "form-cps-register" });
        })
        .catch(error => {
          switch (error.response.data) {
            case RegistrationStatus.InvalidPassword:
              this.linkError = this.$texts.invalidPasswordLinkingError;
              break;
            default:
              this.linkError = ErrorHelper.getWebApiErrorMessage(error);
              break;
          }
        })
        .finally(() => {
          this.submitting = false;
        });
    }
  }
}
